import { ArpMedia, SamplePack } from '@arpeggi/shared'
import { Box } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { FileError } from '../../../../utils/forms'
import { requiresUserLoggedIn } from '../../../AuthFlow/AuthFlowModal'
import { Modal } from '../../../core/Modal'
import { OptionalFields, Page, State, useRegisterSongModal } from './hooks/useRegisterSongModal'
import { RegisterSongModalContent } from './RegisterSongModalContent'

export const RegisterModalContext = React.createContext<{
  state: State
  nextPage: () => void
  previousPage: () => void
  reset: () => void
  setWavFile: (file: File) => void
  setWavFileErrors: (errors: FileError[]) => void
  clearWavFile: () => void
  setProjectFile: (file: File) => void
  setProjectFileErrors: (errors: FileError[]) => void
  clearProjectFile: () => void
  setTitle: (value?: string) => void
  setGenres: (value: string[]) => void
  setKey: (value?: number) => void
  setBpm: (value?: number) => void
  setColor: (value?: string) => void
  setDetectedSubComponentIds: (subComponentIds: number[]) => void
  setCustomWalletAddress: (value?: string) => void
  addSelectedSubComponent: (id: number) => void
  removeSelectedSubComponent: (id: number) => void
  isLastPage: boolean
  isFirstPage: boolean
  isNextPageAllowed: boolean
  shouldPredictSplits: boolean
}>(null)

interface Props {
  trigger?: JSX.Element
  shouldPredictSplits?: boolean
  optionalFields?: OptionalFields
  remixOfSamplePack?: SamplePack
  sounds?: ArpMedia[]
  open?: boolean
  onOpenChange?: (value: boolean) => void
}

export const RegisterSongModal = observer(
  ({
    trigger,
    shouldPredictSplits = false,
    optionalFields = {},
    remixOfSamplePack,
    sounds,
    open,
    onOpenChange
  }: Props) => {
    const registerSongModal = useRegisterSongModal({ optionalFields, remixOfSamplePack, sounds })

    return (
      <RegisterModalContext.Provider value={{ ...registerSongModal, shouldPredictSplits }}>
        <Modal
          open={open}
          trigger={trigger && requiresUserLoggedIn(trigger)}
          noPadding
          closeButtonCss={registerSongModal.isLastPage ? { display: 'none' } : {}}
          onOpenChange={(open) => {
            if (onOpenChange) {
              onOpenChange(open)
            }

            if (registerSongModal.state.page === Page.CONFIRMATION && !open) {
              registerSongModal.reset()
            }
          }}
        >
          <Box
            css={{
              width: registerSongModal.state.page === Page.PUBLISH ? '900px' : '744px',
              maxWidth: '100%',
              padding: '32px'
            }}
          >
            <RegisterSongModalContent />
          </Box>
        </Modal>
      </RegisterModalContext.Provider>
    )
  }
)
